/**
 * Direct deep-link screen for one downstream acquisition lead.
 */
import { escapeHtml } from "./dashboard-html.js";
import { authenticatedFetch } from "./dashboard-auth.js";
import { leadRowHtml } from "./dashboard-lead-inventory.js";
import { downstreamAcquisitionFormsHtml } from "./dashboard-acquisition-forms.js";
import { outOfStageLeadActionsHtml } from "./dashboard-operator-view.js";
import type { LeadFactoryLeadDetailResponse } from "./dashboard-lead-factory-types.js";

export function directDownstreamLeadIdRequested(): string {
  const params = new URLSearchParams(window.location.search);
  const requested = params.get("lf_downstream_direct")?.trim().toLowerCase() ?? "";
  if (requested !== "1" && requested !== "true") return "";
  return params.get("lf_lead_id")?.trim() ?? "";
}

export async function renderDirectDownstreamLead(
  mount: HTMLElement,
  leadId: string,
  bindActions: (statusElement: HTMLElement) => void
): Promise<void> {
  const response = await authenticatedFetch(`/dashboard/lead-factory/leads/${encodeURIComponent(leadId)}`);
  const detail = (await response.json()) as LeadFactoryLeadDetailResponse & { error?: string };
  if (!response.ok) throw new Error(detail.error ?? `Failed to load downstream lead ${leadId}: ${response.status}`);
  mount.innerHTML = `
    <main class="dashboard-shell downstream-direct" data-downstream-direct>
      <section class="panel">
        <div class="panel-heading">
          <div>
            <h1>Downstream Lead</h1>
            <p class="subtle">${escapeHtml(detail.lead.property_address || detail.lead.owner_name || detail.lead.id)}</p>
          </div>
          <a class="button secondary" href="/">Dashboard</a>
        </div>
        <table class="lead-table">
          <tbody>
            ${leadRowHtml(detail.lead)}
          </tbody>
        </table>
        ${outOfStageLeadActionsHtml(detail.lead.id)}
        ${downstreamAcquisitionFormsHtml(detail.lead)}
      </section>
      <aside id="county-detail" class="detail-drawer" aria-live="polite"></aside>
      <p id="action-status" class="action-status" role="status" aria-live="polite">Downstream lead loaded.</p>
    </main>
  `;
  const statusElement = document.querySelector<HTMLElement>("#action-status");
  if (!statusElement) throw new Error("Missing dashboard element #action-status");
  bindActions(statusElement);
}
